import { VectorizationStatus } from "../services/document-manager-service";
import success from "assets/images/success-logo.svg";
import pending from "assets/images/pending-logo.svg";
import inProgress from "assets/images/inprogress-logo.svg";
import failed from "assets/images/failed-logo.svg";

const statusConfig: Record<VectorizationStatus, { icon: string }> = {
    [VectorizationStatus.PENDING]: { icon: pending },
    [VectorizationStatus.IN_PROGRESS]: { icon: inProgress },
    [VectorizationStatus.SUCCESS]: { icon: success },
    [VectorizationStatus.FAILED]: { icon: failed },
};

export const StatusBadge = ({ status }: { status: VectorizationStatus }) => {
    const { icon } = statusConfig[status];
    return (
        <span className="px-2 flex-shrink-0 flex items-center justify-center rounded-lg">
            <img src={icon} alt="status-icon" />
        </span>
    );
};
